import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { CuttingButt } from '../../models/cutting/cutting-butt.model';
import { CadModelsDetailsInfoMaterial } from '../../models/cutting/cutting-cad-model-details.model';
import { CuttingCadModel } from '../../models/cutting/cutting-cad-model.model';
import { DraftBlock } from '../../models/cutting/cutting-draft-block.model';
import { CuttingMaterial } from '../../models/cutting/cutting-material.model';

@Injectable()
export abstract class OrderModelsService {
  public abstract onCadModelsChanged: BehaviorSubject<CuttingCadModel[]>;
  public abstract onCadModelMaterialsParsed: Subject<CuttingCadModel>;

  public abstract uploadCadModelLinkMaterials(
    cadModel: CuttingCadModel,
    isRereadOriginal?: boolean
  ): Observable<CuttingCadModel>;
  public abstract deleteCadModel(idFile: number): Observable<void>;
  public abstract deleteCadModels(fileIds: number[]): Observable<void>;
  public abstract setCadModelDraftBlockMode(modelId: number, draftBlocks: DraftBlock[]): Observable<void>;
  public abstract downloadCadModel(modelId: number): Observable<{ body: Blob; filename: string }>;
  public abstract uploadCadModel(
    uploadedFiles: File[],
    orderId: number,
    readSettings?: { checkFurniture: boolean; checkAssembly: boolean }
  ): Observable<void>;
  public abstract findMaterialInMatbase(materials: string[]): Observable<{ [key: string]: CuttingMaterial }>;
  public abstract findButtMaterialInMatbase(materials: string[]): Observable<{ [key: string]: CuttingButt }>;
  public abstract getCadModelDetails(modelId: number): Observable<CadModelsDetailsInfoMaterial[]>;
  public abstract updateCadModelDetails(
    modelId: number,
    materials: CadModelsDetailsInfoMaterial[]
  ): Observable<CadModelsDetailsInfoMaterial[]>;
}
